export const CUSTOMERAREA = 'espace-client'
export const REGEX_IMG = /(jpg)|(jpeg)|(png)/
export const WEBSITE_LINK = 'https://www.moderlab.com'
